/* eslint react/no-did-mount-set-state: 0 */
import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link,
} from 'react-router-dom';
import logo from './logo.svg';
import './App.css';

import MoviesList from './MoviesList';
import MovieDetail from './MovieDetail';

const App = () => (
  <Router>
    <div className="App">
      <header className="App-header">
        <Link to={`${process.env.PUBLIC_URL}/`}>
          <img src={logo} className="App-logo" alt="logo" />
        </Link>
      </header>
      <Switch>
        <Route path={`${process.env.PUBLIC_URL}/` + ':id'} component={MovieDetail} />
        <Route path={`${process.env.PUBLIC_URL}/`} component={MoviesList} />
      </Switch>
    </div>
  </Router>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js